import React from 'react'

const ErrorView = () => <h1>Please contact #cp-order-support via Slack</h1>

export default ErrorView
